export default __webpack_public_path__ + "static/media/Spinegrist.f8b5e8bb.jpg";